import { isMustacheStatement } from 'modules/handlebars/domain/statement/utils';
import { createStringLiteral } from 'modules/handlebars/domain/literal/utils';
import { isNotNull } from 'utils/tsHelpers';

import { getStatements } from './getStatements';
import { getStatement } from './getStatement';

export const parseDateParameter = (dateParameter: string) => {
  const dateParameterStatement = getStatement(getStatements(dateParameter));
  return isNotNull(dateParameterStatement) && isMustacheStatement(dateParameterStatement)
    ? dateParameterStatement.path
    : createStringLiteral(dateParameter);
};
